import Box from "@mui/material/Box";
import HomeVideo from "assets/images/video.mp4";
import Banner from "components/banner";
import Feature from "components/feature";
import Iconify from "components/iconify";
import PackageDealCard from "components/packageDealCard";
import PopularFlight from "components/popluar-flight";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "video-react/dist/video-react.css";

import Partner1 from "assets/images/Partner1.svg";
import Partner2 from "assets/images/anvrLogo.svg";
import AppIcon from "assets/images/appIcon.png";
import Partner4 from "assets/images/iataLogo.svg";
import Partner3 from "assets/images/sgrLogo.svg";

import Skeleton from "@mui/material/Skeleton";
import { getPackageDeals } from "api/PackageDeals";
import useFilter from "components/filterConfiguration";
import { getUserFromLocalStorage } from "hooks/LocalStorage";
import useApi from "hooks/useApi";
import { useTranslation } from "i18n";
import { CurrencyContext } from "pages/useContext";

import "./style.css";

function Home({ setRedirectLink }) {
  const { t } = useTranslation();
  const [departureDate, setdepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currency } = useContext(CurrencyContext);

  const { allFilters, setAllFilters } = useFilter();
  const packageDealsApi = useApi(getPackageDeals);

  useEffect(() => {
    packageDealsApi.request(currency);
  }, [currency?.currency]);

  const deals = packageDealsApi.data?.deals || [];
  const paymentMethods = [
    {
      key: "creditCard",
      icon: "simple-icons:visa",
      logoLabel: "Visa / Mastercard",
      logoClass: "cards",
    },
    {
      key: "ideal",
      icon: "simple-icons:ideal",
      logoLabel: "iDEAL",
      logoClass: "ideal",
    },
    {
      key: "tikkie",
      icon: "simple-icons:tikkie",
      logoLabel: "Tikkie",
      logoClass: "tikkie",
    },
    {
      key: "applePay",
      icon: "simple-icons:applepay",
      logoLabel: "Apple Pay",
      logoClass: "apple-pay",
    },
    {
      key: "sepa",
      icon: "simple-icons:sepa",
      logoLabel: "SEPA",
      logoClass: "sepa",
    },
    {
      key: "cartesBancaires",
      icon: "simple-icons:cartesbancaires",
      logoLabel: "CB",
      logoClass: "cartes-bancaires",
    },
    {
      key: "blik",
      icon: "simple-icons:blik",
      logoLabel: "BLIK",
      logoClass: "blik",
    },
    {
      key: "bancontact",
      icon: "simple-icons:bancontact",
      logoLabel: "Bancontact",
      logoClass: "bancontact",
    },
    {
      key: "mobilePay",
      icon: "simple-icons:mobilepay",
      logoLabel: "MobilePay",
      logoClass: "mobilepay",
    },
    {
      key: "bankTransfer",
      icon: "mdi:bank-transfer",
      logoLabel: "IBAN",
      logoClass: "bank-transfer",
    },
  ];

  const appFeatures = [
    { key: "searchCheapestFlights", icon: "mdi:magnify" },
    { key: "seatSelections", icon: "mdi:seat-recline-extra" },
    { key: "freeReservations", icon: "mdi:calendar-check" },
    { key: "liveSchedules", icon: "mdi:airplane-clock" },
  ];

  const [presetRoute, setPresetRoute] = useState(null);

  const popularRoutes = [
    {
      inbound: "Amsterdam",
      outbound: "Paramaribo",
      originCode: "AMS",
      destinationCode: "PBM",
      source:
        "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Suriname.png",
    },
    {
      inbound: "Amsterdam",
      outbound: "Dubai",
      originCode: "AMS",
      destinationCode: "DXB",
      source: "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Dubai.png",
    },
    {
      inbound: "Paramaribo",
      outbound: "Amsterdam",
      originCode: "PBM",
      destinationCode: "AMS",
      source:
        "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Asmterdam.png",
    },
    {
      inbound: "Paramaribo",
      outbound: "Miami",
      originCode: "PBM",
      destinationCode: "MIA",
      source: "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Miami.png",
    },
    {
      inbound: "Paramaribo",
      outbound: "Curacao",
      originCode: "PBM",
      destinationCode: "CUR",
      source:
        "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Curacao.png",
    },
    {
      inbound: "Paramaribo",
      outbound: "Aruba",
      originCode: "PBM",
      destinationCode: "AUA",
      source: "https://suriwebwinkel-bucket.s3.us-east-2.amazonaws.com/Aruba.png",
    },
  ];

  const handlePopularRouteClick = (route) => {
    setPresetRoute({
      origin: { cityCode: route.originCode, cityName: route.inbound },
      destination: {
        cityCode: route.destinationCode,
        cityName: route.outbound,
      },
      nonce: Date.now(),
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
    document.querySelector(".home-page .banner")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div>
      <div className="home-page">
        {/**** Hero + Search Engine ****/}
        <div className="banner banner-bg row m-0">
          <div className="home-image px-0">
            <Box overflow="hidden" position="relative" height="100%">
              <div
                className="home-hero-video"
                dangerouslySetInnerHTML={{
                  __html: `<video style="width:100%;height:100%;object-fit:cover;" preload="auto" autoplay loop muted playsinline>
                    <source src=${HomeVideo} type="video/mp4" />
                  </video>`,
                }}
              />
            </Box>
          </div>
          <div className="container">
            {getUserFromLocalStorage() ? (
              <h1>
                {t("home.welcome")},{" "}
                {getUserFromLocalStorage()?.type === "B_AGENT"
                  ? getUserFromLocalStorage()?.travelAgencyName
                  : getUserFromLocalStorage()?.firstName +
                    " " +
                    getUserFromLocalStorage()?.lastName}
              </h1>
            ) : (
              <h1>{t("home.welcome")}</h1>
            )}
            <p className="banner-sub-title mb-16">{t("home.heroSubtitle")}</p>
            <Banner
              departureDate={departureDate}
              setdepartureDate={setdepartureDate}
              returnDate={returnDate}
              setReturnDate={setReturnDate}
              allFilters={allFilters}
              setAllFilters={setAllFilters}
              setRedirectLink={setRedirectLink}
              showQuickRoutes
              presetRoute={presetRoute}
            />
          </div>
        </div>

        {/**** Payment Methods ****/}
        <section className="home-payment-methods">
          <div className="container">
            <div className="home-payment-methods__content">
              <div className="home-payment-methods__layout">
                <div className="home-payment-methods__main">
                  <div className="home-payment-methods__copy">
                    <span>{t("home.paymentMethods.eyebrow")}</span>
                    <h2>{t("home.paymentMethods.title")}</h2>
                    <p>{t("home.paymentMethods.subtitle")}</p>
                    <p className="home-payment-methods__security">
                      {t("home.paymentMethods.securityNote")}
                    </p>
                  </div>
                  <div className="home-payment-methods__showcase">
                    <div className="home-payment-methods__carousel">
                      <div className="home-payment-methods__track">
                        {[...paymentMethods, ...paymentMethods].map(
                          (method, index) => (
                            <div
                              className="home-payment-methods__card"
                              key={`${method.key}-${index}`}
                            >
                              <div
                                className={`home-payment-methods__logo home-payment-methods__logo--${method.logoClass}`}
                              >
                                <Iconify icon={method.icon} width={28} />
                                <span>{method.logoLabel}</span>
                              </div>
                              <h3>
                                {t(
                                  `home.paymentMethods.methods.${method.key}.title`
                                )}
                              </h3>
                              <p>
                                {t(
                                  `home.paymentMethods.methods.${method.key}.body`
                                )}
                              </p>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <aside className="home-payment-methods__klarna">
                  <div className="home-payment-methods__klarna-logo">
                    <Iconify icon="simple-icons:klarna" width={38} />
                    <span>Klarna</span>
                  </div>
                  <span className="home-payment-methods__klarna-badge">
                    {t("home.paymentMethods.klarnaSpotlight.badge")}
                  </span>
                  <h3>{t("home.paymentMethods.klarnaSpotlight.title")}</h3>
                  <p>{t("home.paymentMethods.klarnaSpotlight.body")}</p>
                  <small>{t("home.paymentMethods.klarnaSpotlight.note")}</small>
                </aside>
              </div>
            </div>
          </div>
        </section>

        {/**** Package Deals ****/}
        <div className="home-package-deals">
          <div className="container my-5 py-5">
            <div className="d-flex justify-content-between align-items-end flex-wrap mb-4 gap-2">
              <div className="section-header section-header--left">
                <span>{t("home.dealsEyebrow")}</span>
                <h2>{t("packageDeals.title")}</h2>
                {deals.length > 0 && <p>{t("home.packageSubtitle")}</p>}
              </div>
              {deals.length > 0 && (
                <Link to="/package-deals" className="home-package-deals__link">
                  {t("home.viewAll")}
                  <Iconify icon="mdi:arrow-right" width={18} />
                </Link>
              )}
            </div>
            {packageDealsApi.loading ? (
              <div className="row justify-content-center">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="col-md-6 col-lg-3 mb-4">
                    <Box
                      sx={{
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                        border: "1px solid rgba(0, 0, 0, 0.04)",
                        minHeight: 300,
                        position: "relative",
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        height={300}
                        animation="wave"
                        sx={{
                          position: "absolute",
                          inset: 0,
                          borderRadius: 0,
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          p: "24px 20px 20px",
                          background:
                            "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.7) 100%)",
                        }}
                      >
                        <Skeleton
                          variant="text"
                          width="85%"
                          height={26}
                          animation="wave"
                          sx={{ mb: 1.5 }}
                        />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={1}
                        >
                          <Skeleton
                            variant="text"
                            width={80}
                            height={20}
                            animation="wave"
                          />
                          <Skeleton
                            variant="text"
                            width={70}
                            height={22}
                            animation="wave"
                          />
                        </Box>
                        <Skeleton
                          variant="text"
                          width={140}
                          height={18}
                          animation="wave"
                        />
                      </Box>
                    </Box>
                  </div>
                ))}
              </div>
            ) : packageDealsApi.error ? (
              <Box textAlign="center" py={6} color="text.secondary">
                {t("packageDeals.loadError")}
              </Box>
            ) : deals.length === 0 ? (
              <Box textAlign="center" py={6} color="text.secondary">
                {t("packageDeals.empty")}
              </Box>
            ) : (
              <div className="row justify-content-start">
                {deals.map((deal) => (
                  <div key={deal._id} className="col-md-6 col-lg-3 mb-4">
                    <PackageDealCard
                      deal={deal}
                      currency={currency}
                      onClick={(d) => navigate(`/package-deals/${d?._id}`)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/**** Features ****/}
        <div className="features-section">
          <div className="container features">
            <div className="features__header">
              <span>{t("home.supportEyebrow")}</span>
              <h1>{t("home.supportTitle")}</h1>
              <p>{t("home.supportSubtitle")}</p>
            </div>
            <Box className="row" my={6}>
              <div className="col-md-4">
                <Feature
                  label={t("home.supportCards.change.label")}
                  header={t("home.supportCards.change.title")}
                  body={t("home.supportCards.change.body")}
                  icon="mdi:calendar-refresh"
                />
              </div>
              <div className="col-md-4">
                <Feature
                  label={t("home.supportCards.help.label")}
                  header={t("home.supportCards.help.title")}
                  body={t("home.supportCards.help.body")}
                  icon="mdi:face-agent"
                />
              </div>
              <div className="col-md-4">
                <Feature
                  label={t("home.supportCards.baggage.label")}
                  header={t("home.supportCards.baggage.title")}
                  body={t("home.supportCards.baggage.body")}
                  icon="mdi:bag-suitcase"
                />
              </div>
            </Box>
          </div>
        </div>

        {/**** Mobile App ****/}
        <section className="app-promo">
          <div className="container">
            <div className="app-promo__card">
              <div className="app-promo__glow app-promo__glow--one" />
              <div className="app-promo__glow app-promo__glow--two" />
              <div className="row align-items-center position-relative">
                <div className="col-lg-7">
                  <div className="app-promo__copy">
                    <p className="app-promo__brand">{t("home.appBrand")}</p>
                    <h2>{t("home.appComingSoon")}</h2>
                    <p className="app-promo__subtitle">
                      {t("home.appSubtitle")}
                    </p>
                    <div className="app-promo__features">
                      {appFeatures.map((feature) => (
                        <div className="app-promo__feature" key={feature.key}>
                          <span className="app-promo__feature-icon">
                            <Iconify icon={feature.icon} width={20} />
                          </span>
                          <p>{t(`home.${feature.key}`)}</p>
                        </div>
                      ))}
                    </div>
                    <div className="app-promo__stores">
                      <span className="app-promo__store">
                        <Iconify icon="mdi:apple" width={18} />
                        {t("home.appStore")}
                      </span>
                      <span className="app-promo__store">
                        <Iconify icon="mdi:google-play" width={18} />
                        {t("home.playStore")}
                      </span>
                    </div>
                    <p className="app-promo__stores-note">{t("home.appStores")}</p>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="app-promo__visual">
                    <img
                      src={AppIcon}
                      alt={t("home.appBrand")}
                      className="app-promo__icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/**** Popular Destinations ****/}
        <section className="home-popular">
          <div className="container">
            <div className="section-header">
              <span>{t("home.popularEyebrow")}</span>
              <h2>{t("home.popularDestinations")}</h2>
              <p>{t("home.popularSubtitle")}</p>
            </div>
            <div className="row">
              {popularRoutes.map((route) => (
                <div
                  className="col-md-6 col-lg-4"
                  key={`${route.inbound}-${route.outbound}`}
                >
                  <PopularFlight
                    inbound={route.inbound}
                    outbound={route.outbound}
                    originCode={route.originCode}
                    destinationCode={route.destinationCode}
                    source={route.source}
                    onClick={() => handlePopularRouteClick(route)}
                  />
                </div>
              ))}
            </div>
            <div className="home-popular__actions">
              <button className="btn global-btn">{t("home.showMore")}</button>
            </div>
          </div>
        </section>

        {/**** Partners ****/}
        <section className="home-partners">
          <div className="container">
            <p className="home-partners__title">{t("home.partnersTitle")}</p>
            <div className="home-partners__logos">
              <img src={Partner4} alt="IATA" />
              <img src={Partner2} alt="ANVR" />
              <img src={Partner1} alt="Partner" />
              <img src={Partner3} alt="SGR" />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
